import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './AuthContext/AuthContext';
import { EnvironmentProvider } from './EnvironmentContext/EnvironmentContext';
import { IntercomProvider } from './IntercomContext/IntercomContext';
import { IntlProvider } from './IntlContext/IntlContext';
import { ToastProvider } from 'components/V1/Toast/Toast';

interface AppProvidersProps {
  children: React.ReactNode;
}

function AppProviders({ children }: AppProvidersProps) {
  return (
    <Router>
      <AuthProvider>
        <IntlProvider defaultLocale="en">
          <EnvironmentProvider>
            <IntercomProvider>
              <ToastProvider>{children}</ToastProvider>
            </IntercomProvider>
          </EnvironmentProvider>
        </IntlProvider>
      </AuthProvider>
    </Router>
  );
}

export { AppProviders };
